import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

const SPE_J_PIX = '/spe-j-pix';
let SpeJPixProxy = class SpeJPixProxy {
    constructor(api) {
        this.api = api;
    }
    findReceiptPix(transactionId) {
        const uri = `${SPE_J_PIX}/api/pix/transaction/consult/${transactionId}`;
        return this.api.get(uri);
    }
};
SpeJPixProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJPixProxy);

const SPE_N_PRE_PIX_PROXY = '/spe-n-pre-pix';
let SpeNPixProxy = class SpeNPixProxy {
    constructor(api) {
        this.api = api;
    }
    registerKey(keyType, key) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/`;
        const body = {
            keyType,
            key,
        };
        return this.api.post(uri, body).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    updateKey(uuidAccountPayment, keyType, key) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/`;
        let prepix;
        const body = {
            uuidAccountPayment,
            keyType,
            key,
        };
        return this.api.put(uri, body).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Chave atualizado com sucesso!',
                    data: result,
                };
                return prepix;
            }
            throw 'Houve um erro ao salvar os dados!';
        }), catchError((err) => {
            prepix = {
                message: err,
                data: null,
            };
            return of(prepix);
        }));
    }
    deleteKey(uuidAccountPayment, uuid) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/?uuidAccountPayment=${uuidAccountPayment}&uuid=${uuid}`;
        return this.api.delete(uri, uuidAccountPayment).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    createClaims(createRequest) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/create`;
        return this.api.post(uri, createRequest);
    }
    claimsValidation(claimsValidation) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-transfer/validation`;
        return this.api.post(uri, claimsValidation);
    }
    claimsDonor(uuidPixClaim) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-transfer/donor/${uuidPixClaim}`;
        return this.api.post(uri, uuidPixClaim);
    }
    claimTransferCancelRequested(claimTranferValidation) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-transfer/cancel/requested`;
        return this.api.post(uri, claimTranferValidation);
    }
    confirmClaims(claimRequest) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/confirm`;
        return this.api.post(uri, claimRequest);
    }
    cancelClaims(claimRequest) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/cancel`;
        return this.api.post(uri, claimRequest);
    }
    paymentByQrCode(uuidAccountPayment, data, isKey) {
        let uri = `${SPE_N_PRE_PIX_PROXY}/v1/find-data-payment-by-qrcode/${uuidAccountPayment}`;
        const body = {
            emv: data,
            isKey,
        };
        return this.api.post(uri, body);
    }
    generateEncodeKey(body) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/encode-key/`;
        return this.api.post(uri, body);
    }
    paymentByKey(uuidAccountPayment, key) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/key/find-data-payment-by-key`;
        const obj = {
            uuidAccountPayment,
            key
        };
        return this.api.post(uri, obj);
    }
    createCodeClaimValidation(body) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-code/create`;
        return this.api.post(uri, body);
    }
    validationClaimCode(body) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-code/validation`;
        return this.api.post(uri, body);
    }
};
SpeNPixProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNPixProxy);

const SPE_VIEW_N_PRE_PIX_PROXY = '/spe-view-n-pre-pix';
let SpeViewNPrePixProxy = class SpeViewNPrePixProxy {
    constructor(api) {
        this.api = api;
    }
    getAllKey(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/registry-key/by-account/${uuidAccountPayment}`;
        let prepix;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Chaves cadastradas!',
                    data: result,
                };
                return prepix;
            }
            throw 'Houve um erro ao salvar os dados!';
        }), catchError((err) => {
            prepix = {
                message: err,
                data: null,
            };
            return of(prepix);
        }));
    }
    getAllKeyByAccountActive(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/registry-key/by-account-active/${uuidAccountPayment}`;
        return this.api.get(uri).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    getClaimsPayshop(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/claims/by-account/${uuidAccountPayment}`;
        return this.api.get(uri).pipe(map((result) => {
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    getClaims(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/claims/topazio/${uuidAccountPayment}`;
        return this.api.get(uri).pipe(map((result) => {
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    /* /spe-view-n-pre-pix/v1/claims/participants/ */
    getParticipant() {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/claims/participants/`;
        return this.api.get(uri);
    }
};
SpeViewNPrePixProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNPrePixProxy);

let UiPxPixModule = class UiPxPixModule {
};
UiPxPixModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeJPixProxy,
            SpeNPixProxy,
            SpeViewNPrePixProxy
        ]
    })
], UiPxPixModule);

class ClaimValidation {
}

class PrePixKeys {
}

class RequestQrCodeDto {
}

class PixClaimTransferValidationDto {
}

export { ClaimValidation, PixClaimTransferValidationDto, PrePixKeys, RequestQrCodeDto, SpeJPixProxy, SpeNPixProxy, SpeViewNPrePixProxy, UiPxPixModule };
//# sourceMappingURL=wlp-ui-px-pix.js.map
